module.exports = __webpack_public_path__ + "af25d03a0eb4e2fdf31306107082bcd6.png";